import { connect } from 'react-redux';
import ProfileSelector from './components/ProfileSelector';
import { getProfiles } from '../selectors';
import { selectProfile } from './actions';

const mapStateToProps = state => ({
  profiles: getProfiles(state),
  currentProfile: state.app.auth.profile || {}, // TODO SELECTORS
});
const mapDispatchToProps = dispatch => ({
  select: (profile) => {
    dispatch(selectProfile(profile));
  },
});
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ProfileSelector);
